import { MainPadding } from "../../../styles/Main.styles";
import { useState } from "react";
import TableHeader from "../../../components/table/TableHeader";
import { useNavigate } from "react-router";
import { useGetSuppliers } from "../api/supplier/resolver";
import TableFC, {
  TableFCBodyProps,
  TableHeadProps,
} from "../../../components/table/Table";

export default function Main() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const { data: dataRawSupplier, isLoading: loadingFetchSupplier } =
    useGetSuppliers({ keyword, page, perPage });
  const dataSupplier = dataRawSupplier?.data.data.data;
  const header: TableHeadProps[] = [
    { title: "No" },
    { title: "Nama" },
    { title: "Telp" },
    { title: "Alamat" },
    { title: "Catatan" },
  ];
  const body: TableFCBodyProps[] = [
    { key: "supplier_name" },
    { key: "supplier_phone_number" },
    { key: "supplier_address" },
    { key: "description" },
  ];

  return (
    <MainPadding>
      <TableHeader
        addButton
        filterLabel="Search Supplier"
        searchBar
        onSearch={(e) => setKeyword(e)}
        onClickAdd={() => navigate("/supplier/creation")}
      />
      <TableFC
        loading={loadingFetchSupplier}
        data={dataSupplier}
        body={body}
        showIndex
        totalRows={dataRawSupplier?.data.data.total}
        perColumns={perPage}
        onPerPageChange={(e) => setPerPage(e)}
        head={header}
        onPageChange={(e) => setPage(e)}
        onCellClick={(e) => navigate(`/supplier/creation/${e.id}`)}
      />
    </MainPadding>
  );
}
